import { usePathname, useSearchParams } from "solito/navigation";

import log from "src/helpers/log";
import useStabilizedCallback from "./useStabilizedCallback";

const useCreateCallbackUrl = () => {
	const pathname = usePathname();
	const search = useSearchParams();
	const createCallbackUrl = useStabilizedCallback(
		({ addParams }: { addParams?: Record<string, string> } = {}) => {
			if (!pathname) {
				log.error("No pathname found when creating callback URL");
				return;
			}
			const newSearch = new URLSearchParams(search);
			if (addParams) {
				for (const [key, value] of Object.entries(addParams)) {
					newSearch.set(key, value);
				}
			}
			if (search) {
				search.forEach((value, key) => {
					newSearch.set(key, value);
				});
			}
			const stringifiedSearch = newSearch.toString();

			const callbackUrl = encodeURIComponent(
				pathname + (stringifiedSearch ? `?${stringifiedSearch}` : ""),
			);
			return callbackUrl;
		},
		[pathname, search],
	);
	return createCallbackUrl;
};
export default useCreateCallbackUrl;
